import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ProtectedRoute, AdminRoute } from "./components/ProtectedRoute";

// Pages
import HomePage from "./pages/HomePage";
import VillaPage from "./pages/VillaPage";
import GardenPage from "./pages/GardenPage";
import BookingPage from "./pages/BookingPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ContactPage from "./pages/ContactPage";
import MyReservationsPage from "./pages/MyReservationsPage";

// Admin Pages
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminReservations from "./pages/admin/AdminReservations";
import AdminPricing from "./pages/admin/AdminPricing";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminTestimonials from "./pages/admin/AdminTestimonials";

function AppLayout({ children, showNavbar = true, showFooter = true }) {
  return (
    <>
      {showNavbar && <Navbar />}
      <main>{children}</main>
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <AppLayout>
                <HomePage />
              </AppLayout>
            }
          />
          <Route
            path="/villa"
            element={
              <AppLayout>
                <VillaPage />
              </AppLayout>
            }
          />
          <Route
            path="/jardin"
            element={
              <AppLayout>
                <GardenPage />
              </AppLayout>
            }
          />
          <Route
            path="/reservar"
            element={
              <AppLayout>
                <BookingPage />
              </AppLayout>
            }
          />
          <Route
            path="/reservacion-enviada"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <BookingSuccessPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacto"
            element={
              <AppLayout>
                <ContactPage />
              </AppLayout>
            }
          />

          {/* Auth Routes */}
          <Route
            path="/login"
            element={
              <AppLayout showNavbar={false} showFooter={false}>
                <LoginPage />
              </AppLayout>
            }
          />
          <Route
            path="/registro"
            element={
              <AppLayout showNavbar={false} showFooter={false}>
                <RegisterPage />
              </AppLayout>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/mis-reservaciones"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <MyReservationsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="reservaciones" element={<AdminReservations />} />
            <Route path="precios" element={<AdminPricing />} />
            <Route path="consultas" element={<AdminInquiries />} />
            <Route path="testimonios" element={<AdminTestimonials />} />
          </Route>
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
